import { useEffect, useRef } from "react";
import { FieldsGrid } from "../../../components/molecules";
import { isEqual } from "lodash";

const CustomFieldsGrid = ({
  nameKey,
  values,
  label,
  handleChange,
  fields,
  styleClasses,
  allValues,
  nodes,
  edges,
}) => {
  const preselectedValues = useRef(values);

  useEffect(() => {
    if (values && !isEqual(preselectedValues.current, values)) {
      preselectedValues.current = values;
      handleChange(values, nameKey);
    }
  }, [values, nameKey, handleChange]);

  return (
    <div>
      <FieldsGrid
        name={nameKey}
        values={values}
        label={label}
        fields={fields}
        styleClasses={styleClasses}
        handleChange={handleChange}
        allValues={allValues}
        nodes={nodes}
        edges={edges}
      />
    </div>
  );
};

export default CustomFieldsGrid;
